(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sidebar-collection-cobertor-de-vestir"]) return;
  try {
    
$(".move-filters").prependTo( ".container-filters-ajax" ); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-collection-cobertor"]) return;
  try {
    
$(".move-filters").prependTo( ".container-filters-ajax" ); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-collection-enxoval"]) return;
  try {
    
$(".move-filters").prependTo( ".container-filters-ajax" ); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-collection-estampa"]) return;
  try {
    
$(".move-filters").prependTo( ".container-filters-ajax" ); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-collection-lencol-de-elastico"]) return;
  try {
    
$(".move-filters").prependTo( ".container-filters-ajax" ); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-collection-lencol-de-vestir"]) return;
  try {
    
$(".move-filters").prependTo( ".container-filters-ajax" ); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-collection-mantinha"]) return;
  try {
    
$(".move-filters").prependTo( ".container-filters-ajax" ); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-collection-pe"]) return;
  try {
    
$(".move-filters").prependTo( ".container-filters-ajax" ); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-collection-por-enxoval"]) return;
  try {
    
$(".move-filters").prependTo( ".container-filters-ajax" ); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-collection-por-estampa"]) return;
  try {
    
$(".move-filters").prependTo( ".container-filters-ajax" ); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-collection-toalha-capuz"]) return;
  try {
    
$(".move-filters").prependTo( ".container-filters-ajax" ); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-collection"]) return;
  try {
    
$(".move-filters").prependTo( ".container-filters-ajax" ); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-master"]) return;
  try {
    
$(".move-filters").prependTo( ".container-filters-ajax" ); 

  } catch(e) { console.error(e); }
})();
})();
